export const GET_ALL_SELLER_TAX_GEN_INVOICE = "GET_ALL_SELLER_TAX_GEN_INVOICE";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL";

export const GET_ALL_SELLER_TAX_GEN_INVOICE_BUYER =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_BUYER";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS_BUYER =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SUCCESS_BUYER";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL_BUYER =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_FAIL_BUYER";

export const GET_ALL_SELLER_TAX_GEN_INVOICE_GEN =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_GEN";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_SUCCESS =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_SUCCESS";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_FAIL =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_GEN_FAIL";

export const GET_ALL_SELLER_TAX_GEN_INVOICE_SALE =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_SUCCESS =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_SUCCESS";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_FAIL =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_FAIL";

export const GET_ALL_SELLER_TAX_GEN_INVOICE_LOT =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_LOT_SUCCESS =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_SUCCESS";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_LOT_FAIL =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SALE_FAIL";

export const GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_SUCCESS =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_SUCCESS";
export const GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_FAIL =
  "GET_ALL_SELLER_TAX_GEN_INVOICE_SESSION_FAIL";

export const GET_SELLER_TAX_GEN_BY_ID = "GET_SELLER_TAX_GEN_BY_ID";
export const GET_SELLER_TAX_GEN_AUCTION_BY_ID = "GET_SELLER_TAX_GEN_AUCTION_BY_ID";
export const GET_SELLER_TAX_GEN_BY_ID_SUCCESS =
  "GET_SELLER_TAX_GEN_BY_ID_SUCCESS";
export const GET_SELLER_TAX_GEN_BY_ID_FAIL = "GET_SELLER_TAX_GEN_BY_ID_FAIL";

export const GET_ALL_AUCTION_CENTER_INVOICE = "GET_ALL_AUCTION_CENTER_INVOICE";
export const GET_ALL_AUCTION_CENTER_INVOICE_SUCCESS =
  "GET_ALL_AUCTION_CENTER_INVOICE_SUCCESS";
export const GET_ALL_AUCTION_CENTER_INVOICE_FAIL =
  "GET_ALL_AUCTION_CENTER_INVOICE_FAIL";

export const GET_ALL_CHARGE_TAX = "GET_ALL_CHARGE_TAX";

export const GET_ALL_CHARGE_TAX_SUCCESS = "GET_ALL_CHARGE_TAX_SUCCESS";

export const GET_ALL_CHARGE_TAX_FAIL = "GET_ALL_CHARGE_TAX_FAIL";

export const GET_ALL_ADD_CHARGE_INVOICE = "GET_ALL_ADD_CHARGE_INVOICE";
export const GET_ALL_ADD_CHARGE_INVOICE_SUCCESS =
  "GET_ALL_ADD_CHARGE_INVOICE_SUCCESS";
export const GET_ALL_ADD_CHARGE_INVOICE_FAIL =
  "GET_ALL_ADD_CHARGE_INVOICE_FAIL";

export const GET_SUBMIT_ALL_ADD_CHARGE_INVOICE = "GET_SUBMIT_ALL_ADD_CHARGE_INVOICE";
export const GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_SUCCESS = "GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_SUCCESS";
export const GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_FAIL = "GET_SUBMIT_ALL_ADD_CHARGE_INVOICE_FAIL";
 

export const API_STATUS_SELLER = "API_STATUS_SELLER";

export const GET_SELLER_INVOICE_EXPORT_SUCCESS = 'GET_SELLER_INVOICE_EXPORT_SUCCESS';
export const GET_SELLER_INVOICE_EXPORT_FAIL = 'GET_SELLER_INVOICE_EXPORT_FAIL';